import React from "react";
import { useHistory } from "react-router-dom";
import { Typography, Space } from "@arco-design/web-react";
import { IconGithub, IconMessage } from "@arco-design/web-react/icon";
import { goSWApiDocument, goSWChangeLog } from "../../utils/common";

const { Text } = Typography;

interface FooterProps {
	className?: string;
}

const Footer: React.FC<FooterProps> = ({ className }) => {
	const history = useHistory();
	const currentYear = new Date().getFullYear();

	return (
		<footer className={`footer ${className || ""}`}>
			<div className="footer-container">
				<div className="footer-grid">
					{/* 品牌信息 */}
					<div className="footer-section">
						<div className="footer-brand-title">速问开放平台</div>
						<Text className="footer-brand-description">
							基于先进的大语言模型和向量搜索技术，为医疗行业提供精准的数据洞察和智能服务。
						</Text>
					</div>

					{/* 产品链接 */}
					<div className="footer-section">
						<Text className="footer-section-title">产品</Text>
						<Space direction="vertical" size="small">
							<Text className="footer-link" onClick={goSWApiDocument}>
								文档 ↗
							</Text>
							<Text
								className="footer-link"
								onClick={() => history.push("/interface-debug")}
							>
								API 调试
							</Text>
							<Text
								className="footer-link"
								onClick={() => history.push("/console")}
							>
								开发者控制台
							</Text>
						</Space>
					</div>

					{/* 支持链接 */}
					<div className="footer-section">
						<Text className="footer-section-title">帮助</Text>
						<Space direction="vertical" size="small">
							<Text className="footer-link" onClick={goSWChangeLog}>
								更新日志
							</Text>
							{/* <Text className="footer-link">社区论坛</Text> */}
							{/* <Text className="footer-link">联系我们</Text> */}
						</Space>
					</div>

					{/* 法律链接 */}
					{/* <div className="footer-section">
						<Text className="footer-section-title">法律</Text>
						<Space direction="vertical" size="small">
							<Text className="footer-link">服务条款</Text>
							<Text className="footer-link">隐私政策</Text>
							<Text className="footer-link">数据安全</Text>
						</Space>
					</div> */}
				</div>

				{/* 底部版权和社交链接 */}
				<div className="footer-bottom">
					<Text className="footer-copyright">
						© {currentYear} 速问开放平台. All rights reserved.
					</Text>

					{/* <div className="footer-social">
            <IconGithub className="social-icon" />
            <IconMessage className="social-icon" />
          </div> */}
				</div>
			</div>
		</footer>
	);
};

export default Footer;
